import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * ModalOverlay - Overlay de loading pour modals avec daisyUI
 * @param {boolean} isVisible - Affichage de l'overlay
 * @param {string} text - Texte à afficher
 * @param {string} size - Taille du spinner
 */
const ModalOverlay = ({ 
    isVisible = false, 
    text = 'Chargement...', 
    size = 'lg' 
}) => {
    if (!isVisible) return null;

    const sizeClasses = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-10 h-10',
        xl: 'w-12 h-12'
    };

    return (
        <div className="absolute inset-0 bg-base-100/80 backdrop-blur-sm rounded-lg flex items-center justify-center z-10">
            <div className="flex flex-col items-center space-y-4 p-6">
                <Loader2 className={`animate-spin text-primary ${sizeClasses[size]}`} />
                <span className="text-base-content font-medium">{text}</span>
            </div>
        </div>
    );
};

export default ModalOverlay;
